import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

const Ban = () => <FontAwesomeIcon height="16px" iconName="ban" />;

export const actionItemsIcons = {
  ban: Ban,
};
